import { render } from "./LoginContent.vue?vue&type=template&id=71a27926"
import script from "./LoginContent.vue?vue&type=script&lang=js"
export * from "./LoginContent.vue?vue&type=script&lang=js"

import "./LoginContent.vue?vue&type=style&index=0&id=71a27926&lang=scss"
script.render = render

export default script